import { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import PropTypes from "prop-types";

import {
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
} from "@mui/material";

// Components
import MessageDialog from "../shared/MessageDialog";
import MDCLoader from "../core/MDCLoader";
import DocumentUpload from "../shared/DocumentUpload";
import ErrorText from "../shared/ErrorText";
import MDCRadioButton from "../core/MDCRadioButton";
import MDCText from "../core/MDCText";
import CopyContentIcon from "../iconComponents/CopyContentIcon";
import DesktopIcon from "../iconComponents/DesktopIcon";

// Constants
import { QR_CODE } from "../../constants/messageConstants";
import {
  VollmachtFormConstants,
  documentNames,
  qesIdentOptions,
  PREFILLED_DOCUMENTS_TITLE,
  PREFILLED_DOCUMENTS_FORM_ERROR,
  PPOAdocumentNames,
  PREFILLED_DOCUMENTS_DESCRIPTION,
  SIGNATURE_PROCESS_DOCUMENTS_EMAIL,
  SIGNATURE_PROCESS_DOCUMENTS_EMAIL_NP_DESCRIPTION,
  SIGNATURE_PROCESS_DOCUMENTS_BUTTON_LABEL,
  PREFILLED_DOCUMENTS_BUTTON_LABEL,
  VOLLMACHT_FILE_UPLOAD,
  VOLLMACHT_FILE_UPLOAD_DESCRIPTION,
  vollmachtFileNamesMapping,
  PREVIEW,
  DOWNLOAD,
  IMAGE_FILE_PNG_TYPE,
  PDF_FILE_TYPE,
  SIGNING_PROCESSING_TYPE,
  VOLLMACHT_UPLOADED_FILE_DETAIL_VIEW,
  VollmachtRadioSteps,
} from "../../constants/ManualRequestFormConstants";
import {
  USER_ROLE_APPROVER,
  QES_CURRENT_STAGE,
  QES_STAGE_STATUS,
} from "../../constants/userConstants";
import { COMPONENT_IDS } from "../../constants/RolePermissions";

// Actions
import { manualRequestFormActions } from "../../store/actions/vorgange/manualRequestFormActions";

// Helper
import { formConstants, qrCode } from "../../helpers/vorgange";
//Core Components
import MDCButton from "../core/MDCButton";
import MDCLabel from "../core/MDCLabel";

//Button Icon
import RefreshIcon from "../iconComponents/RefreshIcon";

// Material UI
import Grid from "@mui/material/Grid";
import { withStyles } from "@mui/styles";
import verimiImage from "../../assets/images/verimi-image.PNG";
import downloadPDFLogo from "../../assets/images/Icon_Download_Black.svg";
import theme from "../../themes/mdc-theme";
import MDCStepper from "../core/MDCStepper";
import MDCBanner from "../core/MDCBanner";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import { VollmachtRequestFormAction } from "../../store/actions/vorgange/VollmachtRequestFormAction";
import { socketActions } from "../../store/actions/socket/socketActions";
import MDCModal from "../core/MDCModal";
import carLogo from "../../assets/images/my_digital_car.svg";
import SwitchIcon from "../../assets/images/SwitchIcon.svg";
import iconWarningInfo from "../../assets/images/icon_warning_info.svg";
import MDCCenteredDivider from "../core/MDCCenteredDivider";
import SignatureSendEmailPopupNP from "./inner_components/SignatureSendEmailPopupNP";
import MDCTextWithDescription from "../core/MDCTextWithDescription";

// Utils
import {
  convertBase64StringToBlobURL,
  downloadFileWithBlobURL,
  downloadPdfFromBase64,
  getFileNameFromHttpResponse,
  isVWAGGroup,
  hasRolePermissions,
} from "../../helpers/utils";
import QESSupportDataBox from "./QESSupportDataBox";
import NPQESTypeSwitchModal from "./inner_components/VollamachtTab/NPQESTypeSwitchModal";
import QESProviderSelection from "./inner_components/QESProviderSelection";
import QESSigningStartScreen from "./inner_components/QESSigningStartScreen";
import QESProviderBanner from "../shared/QESProviderBanner";
import { availableVendors } from "../../constants/PluginConstants";
import DeleteProviderFlow from "../userProfile/DeleteProviderFlow";

const styles = () => ({
  formBackGround: {
    padding: "0 3%",
    paddingTop: "4%",
    marginTop: "2% !important",
    background: `${theme.palette.MDCColors.white} 0% 0% no-repeat padding-box`,
    boxShadow: `0px 3px 6px ${theme.palette.MDCColors.color18}`,
    borderRadius: "5px",
    opacity: 1,
    color: theme.palette.MDCColors.textColor,
    fontSize: "1rem",
    fontFamily: theme.palette.typography.fontFamily,
    lineHeight: 1.5,
    minHeight: "30rem",
  },
  detailViewBackground: {
    boxShadow: "none",
    paddingTop: "initial",
  },
  vollmachtCompleted: {
    paddingTop: "1%",
  },
  columnTitle: {
    fontSize: "1rem",
    fontWeight: "bold",
    fontFamily: theme.palette.typography.fontFamily,
    marginBottom: "1.25rem",
  },
  fieldGroup: {
    marginBottom: "1.25rem !important",
  },
  linkLabel: {
    color: theme.palette.MDCColors.color23,
    cursor: "pointer",
  },
  vollmachtStep: {
    display: "flex",
    flexDirection: "column !important",
    marginBottom: "3rem !important",
  },
  vollmachtStep3rd: {
    textAlign: "left",
  },
  width75: {
    width: "75%",
  },
  QRLoader: {
    marginTop: "1.5rem",
    height: "87px",
    width: "18em",
    display: "flex",
    justifyContent: "center",
  },
  vollmachtImage: {
    backgroundRepeat: "no-repeat",
    backgroundSize: "100%",
  },
  verimiImage: {
    backgroundImage: `url(${verimiImage})`,
    height: "300px",
    backgroundSize: "90%",
    backgroundPosition: "center",
  },
  vollmachtDownloadPDF: {
    backgroundImage: `url(${downloadPDFLogo})`,
    height: "22px",
    width: "22px",
  },
  downloadInput: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "80%",
    padding: "0.3rem 0.8rem",
    borderRadius: "5px",
    border: `1px solid ${theme.palette.MDCColors.color23}`,
    color: theme.palette.MDCColors.black,
    marginBottom: "1rem",
    cursor: "pointer",
    "& >label": {
      display: "block",
      flex: 1,
      minWidth: 0,
      marginBottom: 0,
      marginRight: "0.5rem",
      cursor: "pointer",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    "& >div:last-child": {
      flexShrink: 0,
    },
  },
  marginBottomStepper: {
    marginBottom: "2rem",
  },
  stepperDiv: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    height: "50px",
    textAlign: "center",
    marginBottom: "2rem",
    "& >hr": {
      borderStyle: "dotted",
      borderColor: theme.palette.MDCColors.color23,
      width: "45%",
    },
  },
  blinkerDiv: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "3rem",
    width: "3rem",
  },
  stepper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "1.5rem",
    width: "1.5rem",
    backgroundColor: theme.palette.MDCColors.color18,
    borderRadius: "50%",
    padding: "5px 0",
    fontSize: "1.5rem",
    color: theme.palette.MDCColors.black,
  },
  stepperYellow: {
    backgroundColor: theme.palette.MDCColors.color23,
  },
  yellowBlinker: {
    backgroundColor: theme.palette.MDCColors.color23,
    animation: "blinker 0.5s linear none 30 alternate", // Animation for Blinking stepper------------------
  },
  yellowBlinkerInfinite: {
    animationIterationCount: "infinite", // For blinking 2nd stepper infinte times----------------
  },
  "& @keyframes blinker": {
    "100%": {
      height: "3rem",
      width: "3rem",
    },
  },
  circleLoader: {
    marginBottom: "5.5rem",
    border: "3px solid rgba(0, 0, 0, 0.2)",
    borderColor: theme.palette.MDCColors.color23,
    position: "relative",
    display: "inline-block",
    verticalAlign: "top",
    borderRadius: "50%",
    width: "11rem",
    height: "11rem",
  },
  checkMarkDraw: {
    opacity: 1,
    height: "5.5rem",
    width: "2.75rem",
    transformOrigin: "left top",
    borderRight: `3px solid ${theme.palette.MDCColors.color23}`,
    borderTop: `3px solid ${theme.palette.MDCColors.color23}`,
    content: "",
    left: "2.75rem",
    top: "5.5rem",
    position: "absolute",
    animationDuration: "3000ms",
    animationTimingFunction: "ease",
    animationName: "checkmark", // Animation for checkmark--------
    transform: "scaleX(-1) rotate(135deg)",
  },
  headerCss: {
    padding: "2rem",
    alignItems: "center",
  },
  headerColor: { color: theme.palette.MDCColors.black },
  footerCss: {
    padding: "2rem",
  },
  //-------------Animation for checkMark-------
  "@keyframes checkmark ": {
    "0%": {
      height: 0,
      width: 0,
      opacity: 1,
    },
    "20%": {
      height: 0,
      width: "2.75rem",
      opacity: 1,
    },
    "40%": {
      height: "5.5rem",
      width: "2.75rem",
      opacity: 1,
    },
    "100%": {
      height: "5.5rem",
      width: "2.75rem",
      opacity: 1,
    },
  },
  defaultRadioButton: {
    "& .MuiTypography-root.MuiFormControlLabel-label": {
      marginLeft: "0.938rem",
      color: theme.palette.MDCColors.color18,
      fontSize: "1rem",
      fontFamily: theme.palette.typography.fontFamily,
      "&.Mui-disabled": {
        color: theme.palette.MDCColors.color18,
      },
    },
    "& .MuiSvgIcon-root": { color: theme.palette.MDCColors.color23 },
    "&.Mui-disabled .MuiSvgIcon-root": {
      color: theme.palette.MDCColors.color18,
    },
  },
  disabledRadioButton: {
    "& .MuiSvgIcon-root": { color: theme.palette.MDCColors.color18 },
  },
  duplicateRadioButton: {
    "& .MuiSvgIcon-root": { color: theme.palette.MDCColors.color34 },
  },
  sectionPadding: {
    marginLeft: "3.375rem",
  },
  vollmachtSubHeading: {
    fontSize: "0.875rem",
    marginLeft: "3rem",
  },
  vollmachtRadioSubHeading: {
    fontSize: "0.875rem",
    marginLeft: "3rem",
    marginTop: "-0.5rem",
  },
  qesPreviewSection: {
    marginTop: "-1.5rem",
  },
  prefilledDocumentError: {
    marginTop: "0.5rem",
  },
  prefilledDocumentButtonWidth: {
    width: "100%",
  },
  textWrapCSS: { wordBreak: "break-all" },
  centerDivider: {
    display: "flex",
    alignTtems: "center",
    marginTop: "3rem",
    marginBottom: "2rem",
  },
  contentLeftAlign: {
    textAlign: "left",
  },
  copyCotent: {
    fontSize: "0.875rem",
  },
  contentCopyText: {
    color: "5F5F5F",
    fontWeight: "700",
    marginTop: "0.625rem",
  },
});
let signingProcessTimer;

// Verimi keeps its existing, backend-integrated QR/verification flow
// (QESProcessView below) unchanged — it is shown as-is once picked from the
// vendor list, mirroring the Vollmacht data bank (POARecordQES). Every other
// active vendor (YouTrust, Nect Ident, …) goes through QESSigningStartScreen.
const VERIMI_VENDOR_KEY = "VERIMI";

// Fallback vendor for signing processes started before the vendor picker
// existed — the banner must still show a vendor identity on those screens.
const LEGACY_VERIMI_VENDOR = availableVendors.find(
  (vendor) => vendor.providerId === VERIMI_VENDOR_KEY
) || { providerId: VERIMI_VENDOR_KEY, displayName: "Verimi ID-Pass" };

const isAllowedBasketInfoRead = hasRolePermissions(
  COMPONENT_IDS.VERIMI_BASKET_INFO,
  "read"
);

class VollmachtRequestFormNP extends Component {
  constructor(props) {
    super(props);
    // Set the initial input values
    this.state = {
      blinkingValue: 0,
      fileURL: null,
      loadingQRCode: false,
      messageFor: QR_CODE,
      displayMessage: false,
      QRCodeURL: "",
      showCheckmark: false,
      isVollmachtDocumentError: "",
      qesType: this.props.vollmachtSigningStatus?.qesType || "LOCAL",
      displayIdentSwitchModal: false,
      remoteIdentUrl:
        (this.props.vollmachtSigningStatus?.qesType === "REMOTE" &&
          this.props.vollmachtSigningStatus?.remoteIdentUrl) ||
        "",
      showPrefilledDocuments: false,
      showPrefilledDocumentsError: false,
      showPrefilledDocumentsLoader: false,
      showSignatureSendEmail: false,
      qesSupportData: {},
      vollmachtProcess: SIGNING_PROCESSING_TYPE.QES,
      displayQESTypeSwitchModal: false,
      isNPQESTypeSwitch: false,
      selectedQESVendor: null,
      showQESVendorSelection: false,
      showQESVendorCancelConfirm: false,
    };
  }

  getVerimiStepperValue = (signingStatus) => {
    if (
      signingStatus?.currentStage === QES_CURRENT_STAGE.SIGN &&
      signingStatus?.stageStatus === QES_STAGE_STATUS.COMPLETED
    ) {
      return 3;
    }
    if (
      signingStatus?.currentStage === QES_CURRENT_STAGE.IDENT &&
      signingStatus?.stageStatus === QES_STAGE_STATUS.STARTED
    ) {
      return 1;
    }
    if (
      (signingStatus?.currentStage === QES_CURRENT_STAGE.IDENT &&
        signingStatus?.stageStatus === QES_STAGE_STATUS.COMPLETED) ||
      (signingStatus?.currentStage === QES_CURRENT_STAGE.SIGN &&
        signingStatus?.stageStatus === QES_STAGE_STATUS.STARTED) ||
      signingStatus?.currentStage === QES_CURRENT_STAGE.VERIFY
    ) {
      return 2;
    }
    return 0;
  };

  componentDidMount() {
    if (this.props.qesCompleted && isAllowedBasketInfoRead) {
      this.props
        .getQESSupportData(this.props.requestId, "VORGANG")
        .then((resp) => {
          this.setState({ qesSupportData: resp });
        });
    }
    // Fetch vollmacht signing status only in details dialog
    if (this.props.requestId && this.props.isDetailDialog) {
      this.setState({
        blinkingValue: this.getVerimiStepperValue(
          this.props.vollmachtSigningStatus
        ),
        showCheckmark: false,
      });
      this.props.getVollmachtSigningStatus(this.props.requestId).then(() => {
        if (
          this.props.vollmachtSigningStatus?.currentStage &&
          isAllowedBasketInfoRead
        ) {
          this.props
            .getQESSupportData(this.props.requestId, "VORGANG")
            .then((resp) => {
              this.setState({ qesSupportData: resp });
            });
        }
      });
    }

    if (this.props?.vollmachtTabStatus) {
      if (this.props?.vollmachtSigningStatus?.qesType === "REMOTE") {
        this.setState({ qesType: this.props?.vollmachtSigningStatus?.qesType });
        if (this.props.vollmachtSigningStatus?.remoteIdentUrl) {
          this.setState({
            remoteIdentUrl: this.props.vollmachtSigningStatus?.remoteIdentUrl,
          });
        }
        if (
          this.props?.vollmachtSigningStatus?.currentStage ===
            QES_CURRENT_STAGE.IDENT &&
          this.props?.vollmachtSigningStatus?.stageStatus ===
            QES_STAGE_STATUS.STARTED
        ) {
          this.setState({ blinkingValue: 1 });
        } else if (
          (this.props?.vollmachtSigningStatus?.currentStage ===
            QES_CURRENT_STAGE.IDENT &&
            this.props?.vollmachtSigningStatus?.stageStatus ===
              QES_STAGE_STATUS.COMPLETED) ||
          (this.props?.vollmachtSigningStatus?.currentStage ===
            QES_CURRENT_STAGE.SIGN &&
            this.props?.vollmachtSigningStatus?.stageStatus ===
              QES_STAGE_STATUS.STARTED) ||
          this.props?.vollmachtSigningStatus?.currentStage ===
            QES_CURRENT_STAGE.VERIFY
        ) {
          this.setState({ blinkingValue: 2 });
        } else if (
          this.props?.vollmachtSigningStatus?.currentStage ===
            QES_CURRENT_STAGE.SIGN &&
          this.props?.vollmachtSigningStatus?.stageStatus ===
            QES_STAGE_STATUS.COMPLETED
        ) {
          this.setState({ blinkingValue: 3 });
        }
      }
    }

    if (
      this.props?.formValues?.unterzeichnungsprozess?.value ===
        SIGNING_PROCESSING_TYPE.FILE_UPLOAD &&
      this.props.requestId &&
      !this.props.isDetailDialog
    ) {
      this.setState({ showPrefilledDocumentsLoader: true });
      this.props
        .getPrefilledDocumentStatus(this.props.requestId)
        .then((resp) => {
          if (resp) {
            this.setState({
              showPrefilledDocumentsLoader: false,
              showPrefilledDocuments: resp?.prefilledDocumentValidation,
              showPrefilledDocumentsError: !resp?.prefilledDocumentValidation,
            });
          }
        });
    }

    if (
      this.props?.vollmachtSigningStatus?.qrCodeImage &&
      this.props.personenform === formConstants.individualPerson
    ) {
      this.setQRCode();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props?.QRCode !== prevProps.QRCode && !this.props.isDetailDialog) {
      this.setQRCode();
    }

    // Fetch vollmacht signing status only in details dialog
    if (
      prevProps?.vollmachtSigningStatus?.qesType !==
        this.props.vollmachtSigningStatus?.qesType &&
      this.props.isDetailDialog
    ) {
      const qesType = this.props.vollmachtSigningStatus?.qesType;
      this.setState({ qesType });
      if (
        qesType === "REMOTE" &&
        this.props.vollmachtSigningStatus?.remoteIdentUrl
      ) {
        this.setState({
          remoteIdentUrl: this.props.vollmachtSigningStatus?.remoteIdentUrl,
        });
      }
    }
    if (
      this.props?.vollmachtSigningStatus?.qrCodeImage !==
      prevProps?.vollmachtSigningStatus?.qrCodeImage
    ) {
      this.setQRCode();
    }

    const isDetailsDialogWithActiveQES =
      this.props?.isDetailDialog &&
      !!this.props?.vollmachtSigningStatus?.currentStage;
    if (
      (this.props.formValues.unterzeichnungsprozess?.value ===
        SIGNING_PROCESSING_TYPE.QES ||
        isDetailsDialogWithActiveQES) &&
      this.props.vollmachtSigningStatus !== prevProps.vollmachtSigningStatus
    ) {
      const previousCompletedStage =
        prevProps.vollmachtSigningStatus?.currentStage;
      const currentCompletedStage =
        this.props.vollmachtSigningStatus?.currentStage;

      const isDetailDialog = this.props?.isDetailDialog;

      if (isDetailDialog) {
        this.setState({
          blinkingValue: this.getVerimiStepperValue(
            this.props.vollmachtSigningStatus
          ),
          showCheckmark: false,
        });
      }

      if (
        !previousCompletedStage &&
        currentCompletedStage &&
        currentCompletedStage !== previousCompletedStage
      ) {
        //there is an update at halter form so again call to details api
        // Delay for 2 seconds to get the updated data from vorgang details API
        if (!isDetailDialog) {
          setTimeout(() => {
            this.props.updateManualRequestFormField();
          }, 2000);
        }
      }
      if (
        this.props.vollmachtSigningStatus?.currentStage ===
          QES_CURRENT_STAGE.VERIFY &&
        !isDetailDialog
      ) {
        this.props.updateManualRequestFormField();
      }
      if (
        (this.props.vollmachtSigningStatus?.currentStage ===
          QES_CURRENT_STAGE.IDENT &&
          this.props.vollmachtSigningStatus?.stageStatus ===
            QES_STAGE_STATUS.COMPLETED) ||
        (this.props.vollmachtSigningStatus?.currentStage ===
          QES_CURRENT_STAGE.SIGN &&
          this.props.vollmachtSigningStatus?.stageStatus ===
            QES_STAGE_STATUS.STARTED) ||
        this.props.vollmachtSigningStatus?.currentStage ===
          QES_CURRENT_STAGE.VERIFY
      ) {
        this.setState({ blinkingValue: 2 });
        if (!isDetailDialog) {
          this.props.updateManualRequestFormField();
        }
      }
      if (
        this.props.vollmachtSigningStatus?.currentStage ===
          QES_CURRENT_STAGE.SIGN &&
        this.props.vollmachtSigningStatus?.stageStatus ===
          QES_STAGE_STATUS.COMPLETED
      ) {
        if (!isDetailDialog) {
          clearInterval(signingProcessTimer);
          this.props.updateManualRequestFormField();
          this.setState({ blinkingValue: 3, showCheckmark: true });
          //Commenting as BE is already sending same notification in websocket
          // toast.info(
          //   <NotificationMessage
          //     message={`Ihre signierten Vollmachtsdokumente können nun in der manuellen Eingabe des Antrags mit der Vorgangsnummer
          //   ${getCurrentStatusOfRequest(
          //     this.props.vorgangeDetails?.data?.data,
          //     "referenzID_23"
          //   )} eingesehen und heruntergeladen werden`}
          //   />
          // );
          setTimeout(() => {
            this.setState({ showCheckmark: false });
          }, 3000);
        } else {
          this.setState({ blinkingValue: 3, showCheckmark: false });
        }
      }
    }

    if (this.props.vorgangQESUpdatedRecordId === this.props.requestId) {
      this.props.getVollmachtSigningStatus(this.props.requestId);
      this.props.getVorgangQESUpdatedFromSocketEvent(null); // Resetting the recordId in the store after using it.
    }
  }

  componentWillUnmount() {
    clearInterval(signingProcessTimer);
    if (this.props?.vollmachtSigningStatus?.qrCodeImage)
      this.props.resetQRCode(); // Resetting the QR Code on unmounting.
  }

  getVerimiStepperValue = (signingStatus) => {
    if (
      signingStatus?.currentStage === QES_CURRENT_STAGE.SIGN &&
      signingStatus?.stageStatus === QES_STAGE_STATUS.COMPLETED
    ) {
      return 3;
    }
    if (
      signingStatus?.currentStage === QES_CURRENT_STAGE.IDENT &&
      signingStatus?.stageStatus === QES_STAGE_STATUS.STARTED
    ) {
      return 1;
    }
    if (
      (signingStatus?.currentStage === QES_CURRENT_STAGE.IDENT &&
        signingStatus?.stageStatus === QES_STAGE_STATUS.COMPLETED) ||
      (signingStatus?.currentStage === QES_CURRENT_STAGE.SIGN &&
        signingStatus?.stageStatus === QES_STAGE_STATUS.STARTED) ||
      signingStatus?.currentStage === QES_CURRENT_STAGE.VERIFY
    ) {
      return 2;
    }
    return 0;
  };

  setQRCode = async () => {
    const isDetailDialog = this.props?.isDetailDialog;

    let qrCodeImageUrl = "";
    if (this.props?.QRCode) {
      qrCodeImageUrl = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result || "");
        reader.readAsDataURL(this.props?.QRCode);
      });
    }
    if (
      isDetailDialog ||
      this.props?.vollmachtSigningStatus?.currentStage ===
        QES_CURRENT_STAGE.SIGN ||
      (!this.props?.QRCode && this.props?.vollmachtSigningStatus?.qrCodeImage)
    ) {
      qrCodeImageUrl = convertBase64StringToBlobURL(
        this.props?.vollmachtSigningStatus?.qrCodeImage,
        IMAGE_FILE_PNG_TYPE
      );
    }

    this.setState({
      loadingQRCode: false,
      QRCodeURL: qrCodeImageUrl,
      blinkingValue: this.props?.isVollmachtCompleted
        ? 3
        : (this.props.vollmachtSigningStatus?.currentStage ===
            QES_CURRENT_STAGE.IDENT &&
            this.props.vollmachtSigningStatus?.stageStatus ===
              QES_STAGE_STATUS.COMPLETED) ||
          (this.props.vollmachtSigningStatus?.currentStage ===
            QES_CURRENT_STAGE.SIGN &&
            this.props.vollmachtSigningStatus?.stageStatus ===
              QES_STAGE_STATUS.STARTED) ||
          this.props.vollmachtSigningStatus?.currentStage ===
            QES_CURRENT_STAGE.VERIFY
        ? 2
        : 1,
    });
  };

  handleFile(fileName, operation) {
    let base64String =
      fileName === "Adressnachweis"
        ? this.props?.halterFormValues?.addressDocument?.value
        : this.props.formValues[vollmachtFileNamesMapping[fileName]]?.value;

    if (operation === DOWNLOAD) {
      downloadPdfFromBase64(base64String, fileName, true);
      return;
    }

    if (!base64String) {
      return;
    }

    const blobURL = convertBase64StringToBlobURL(base64String, PDF_FILE_TYPE);

    //File Preview in new tab
    if (operation === PREVIEW) {
      window.open(blobURL, "_blank");
      return;
    }

    // For downloading file
    downloadFileWithBlobURL(blobURL, fileName);
  }

  // Signed documents for the Category-2 completion screen — derived the same
  // way as the Verimi "Vollmacht empfangen" step (vollmacht + conditional
  // SEPA / Adressnachweis). The files themselves come from the backend via
  // handleFile, so nothing here is hardcoded.
  getQESSignedDocuments = () => {
    const vollmachtType = this.props?.formValues?.vollmachtsprozess?.value;
    const documents = [
      {
        label:
          vollmachtType === "Einzelvollmacht"
            ? "Einzelvollmacht"
            : "Dauervollmacht",
        fileKey: vollmachtType,
      },
    ];
    if (
      !(
        this.props?.halterFormValues?.Vorhanden?.value ||
        this.props?.halterFormValues?.steuerbefreiung?.value
      )
    ) {
      documents.push({ label: "SEPA-Mandat", fileKey: "SEPA-Mandat" });
    }
    if (this.props?.halterFormValues?.addressDocument?.value) {
      documents.push({ label: "Adressnachweis", fileKey: "Adressnachweis" });
    }
    return documents;
  };

  // Resolve the vendor object for an already-initiated QES from the stored
  // signing status first, so existing records reopen the provider that actually
  // owns the initiated QES process.
  getExistingQESVendor = () => {
    const existing =
      this.props?.vollmachtSigningStatus?.qesProvider ||
      this.props?.existingQesProvider;
    if (!existing) return null;
    const providerId =
      typeof existing === "object"
        ? existing.providerId || existing.key
        : existing;
    return {
      providerId,
      displayName: this.props?.qesProviders?.find(
        (p) => p.providerId === providerId
      )?.displayName,
    };
  };

  handleDialogClose = (userConformation) => {
    this.setState({ displayMessage: false });

    if (userConformation) {
      if (signingProcessTimer) {
        clearInterval(signingProcessTimer);
      }

      this.props.resetVollmachtSignedData();
      this.props
        .getQRCode(this.props.requestId, qrCode.generateNewQRCode)
        .then(() => {
          this.props.getVollmachtSigningStatus(this.props.requestId);
        });

      this.setState({
        loadingQRCode: true,
        blinkingValue: 0,
      });
    }
  };
  handleDocumentAvailableChange = (e) => {
    const { sepaMandat, dauervollmacht } = this.props.formValues;

    const value = e.target.value;

    const isNaturliche =
      this.props.personenform === formConstants.individualPerson;

    if (
      value === SIGNING_PROCESSING_TYPE.QES &&
      (sepaMandat?.value !== "" || dauervollmacht?.value !== "")
    ) {
      this.setState({
        displayQESTypeSwitchModal: false,
        isVollmachtDocumentError:
          "Bitte löschen Sie zunächst die hochgeladenen Dokumente",
      });
    } else {
      this.setState({
        isVollmachtDocumentError: "",
      });
    }

    if (value === SIGNING_PROCESSING_TYPE.FILE_UPLOAD && this.props.requestId) {
      this.setState({
        vollmachtProcess: value,
      });
      if (isNaturliche) {
        this.setState({
          displayQESTypeSwitchModal: true,
        });
      }
      this.props
        .getPrefilledDocumentStatus(this.props.requestId)
        .then((response) => {
          this.setState({
            showPrefilledDocuments: response?.prefilledDocumentValidation,
            showPrefilledDocumentsError: !response?.prefilledDocumentValidation,
          });
        });
    } else if (
      value === SIGNING_PROCESSING_TYPE.QES &&
      !sepaMandat?.value &&
      !dauervollmacht?.value
    ) {
      this.setState({
        vollmachtProcess: value,
      });

      if (isNaturliche) {
        this.setState({
          displayQESTypeSwitchModal: true,
        });
      }
    }
  };

  startRemoteIdentURL = () => {
    this.props
      .startQESProcess(this.props.requestId, {
        providerId: "VERIMI",
        identType: "REMOTE",
      })
      .then((resp) => {
        if (resp?.status === 201) {
          this.props
            .getRemoteIdentURL(this.props.requestId)
            .then((identType) => {
              const { remoteIdentUrl } = identType;
              this.setState({ remoteIdentUrl });
              this.props.getVollmachtSigningStatus(this.props.requestId);
            });
          this.setState({ blinkingValue: 1 });
        }
      });
  };

  handleQESIdentChange = (e) => {
    if (this.props.vollmachtSigningStatus?.currentStage) {
      this.setState({
        displayIdentSwitchModal: true,
      });
    } else {
      this.setState({
        qesType: e.target.value,
      });
    }
  };

  confirmQESIdentChange = () => {
    // Here we are setting the other ident type after successful qes deletion
    const qesIdentType = qesIdentOptions.reduce((accumulator, identType) => {
      if (identType.value !== this.props.vollmachtSigningStatus?.qesType) {
        accumulator = identType.value;
      }
      return accumulator;
    }, "");
    this.props.deleteQESDetails(this.props.requestId).then(() => {
      this.props.getVollmachtSigningStatus(this.props.requestId);
      this.setState({
        qesType: qesIdentType,
        displayIdentSwitchModal: false,
        blinkingValue: 0,
        remoteIdentUrl: "",
        QRCodeURL: "",
      });
      clearInterval(signingProcessTimer);
    });
  };

  copyRemoteIdentURL = () => {
    if (this.state?.remoteIdentUrl) {
      navigator?.clipboard?.writeText(this.state?.remoteIdentUrl);
    }
  };
  generateQRCode = () => {
    if (this.state.QRCodeURL) {
      this.setState({ displayMessage: true });
      return;
    }
    this.setState({ loadingQRCode: true });
    this.props
      .startQESProcess(this.props.requestId, {
        providerId: "VERIMI",
        identType: "LOCAL",
      })
      .then((resp) => {
        if (resp?.status === 201) {
          this.props.getVollmachtSigningStatus(this.props.requestId);
          this.setState({ loadingQRCode: false });
        } else {
          this.setState({ loadingQRCode: false });
        }
      });
  };

  downloadPrefilledDocuments = () => {
    this.setState({ showPrefilledDocumentsLoader: true });
    this.props
      .getPrefilledDocumentsDownload(this.props.requestId)
      .then((resp) => {
        if (resp?.data) {
          this.setState({ showPrefilledDocumentsLoader: false });
          const fileName = getFileNameFromHttpResponse(resp);
          const url = window.URL.createObjectURL(new Blob([resp?.data]));
          downloadFileWithBlobURL(url, fileName);
        }
      });
  };

  handleCloseSendEmail = () => {
    this.setState({
      showSignatureSendEmail: false,
    });
  };

  handleCloseQESTypeSwitchModal = () => {
    this.setState({
      displayQESTypeSwitchModal: false,
    });
  };

  // QES vendor selection: stores the started vendor + person type (NP/JP).
  // Navigation to the next signing screen wires here once its design lands.
  handleQESVendorStart = (vendor, personenform, signingSession) => {
    this.setState({
      selectedQESVendor: { vendor, personenform, signingSession },
      showQESVendorSelection: false,
    });
  };

  handleQESVendorCancelRequest = () => {
    this.setState({ showQESVendorCancelConfirm: true });
  };

  handleHideQESVendorCancelConfirm = () => {
    this.setState({ showQESVendorCancelConfirm: false });
  };

  handleQESVendorCancel = () => {
    this.setState({
      selectedQESVendor: null,
      showQESVendorSelection: true,
      showQESVendorCancelConfirm: false,
    });
  };

  handleQESVendorConfirmCancel = () => {
    this.props.deleteQESDetails(this.props.requestId).then(() => {
      this.props.resetVollmachtSignedData();
      this.props.resetQRCode();
      this.setState({
        blinkingValue: 0,
        fileURL: null,
        loadingQRCode: false,
        displayMessage: false,
        QRCodeURL: "",
        showCheckmark: false,
        isVollmachtDocumentError: "",
        qesType: "LOCAL",
        displayIdentSwitchModal: false,
        remoteIdentUrl: "",
        qesSupportData: {},
        vollmachtProcess: SIGNING_PROCESSING_TYPE.QES,
        displayQESTypeSwitchModal: false,
        isNPQESTypeSwitch: false,
        selectedQESVendor: null,
        showQESVendorSelection: true,
        showQESVendorCancelConfirm: false,
      });
    });
  };

  // Category 2: start the QES process, then refresh signing status on 201.
  handleStartQESProviderProcess = (payload) => {
    return this.props
      .startQESProcess(this.props.requestId, payload)
      .then((resp) => {
        if (resp?.status === 201) {
          this.props.getVollmachtSigningStatus(this.props.requestId);
        }
        return resp;
      });
  };

  handleVollmachtProcess = () => {
    const updatedData = [
      {
        id: "Vollmacht",
        value: [
          {
            id: "IdentDokument",
            value: [
              {
                id: "unterzeichnungsprozess",
                value: this.state.vollmachtProcess,
              },
            ],
          },
        ],
      },
    ];

    this.setState({
      isNPQESTypeSwitch: true,
    });

    this.props.createManualEntry(updatedData, this.props.requestId).then(() => {
      this.props.updateManualRequestFormField(true);
      this.props.getVollmachtSigningStatus(this.props.requestId);
      this.setState({
        displayQESTypeSwitchModal: false,
        isNPQESTypeSwitch: false,
      });
    });
  };

  render() {
    const { blinkingValue, qesType } = this.state;
    const { classes, personenform, halterFormValues } = this.props;
    const authorities = this?.props?.user.roles;
    const isAdminAndSupportUser = !authorities?.includes(USER_ROLE_APPROVER);

    let defaultRadioButtonStyles = `${classes?.defaultRadioButton} ${
      (this.props.isPpoaApplied ||
        this.props?.isVollmachtCompleted ||
        this.props?.isDetailDialog ||
        this.props?.readOnly) &&
      classes?.disabledRadioButton
    }`;

    const getModalHeader = () => {
      return (
        <Grid container className={classes.headerCss}>
          <Grid item xs={7} className={classes.headerColor}>
            <MDCLabel label="Warnung" variant="h6" />
          </Grid>
          <Grid item xs={5}>
            <img alt="My Digital Car" src={carLogo} width="95%" />
          </Grid>
        </Grid>
      );
    };

    const getModalBody = () => {
      return (
        <Grid container className={classes.headerCss} justifyContent="center">
          <img src={SwitchIcon} alt="switch-icon" />
          <Grid container marginY="2.5rem" marginX="1rem">
            <MDCLabel label="Warnung: Mit der Änderung des Ident-Types wird der bestehende Prozess abgebrochen und die damit verbundenen Daten. Möchten Sie den Ident-Typ tatsächlich ändern?" />
          </Grid>
          <Grid container justifyContent="space-between">
            <Grid>
              <MDCButton
                onClick={() =>
                  this.setState({ displayIdentSwitchModal: false })
                }
                variant="outlined"
                label="Abbrechen"
              />
            </Grid>
            <Grid>
              <MDCButton
                onClick={() => this.confirmQESIdentChange()}
                variant="contained"
                label="Bestätigen"
              />
            </Grid>
          </Grid>
        </Grid>
      );
    };

    const qesStepOneLocalIdentView = (
      <>
        <Grid marginBottom="2.5rem">
          <MDCLabel label="Scan" variant="h6" />
          <p className={classes.width75}>
            {VollmachtFormConstants.STEP_ONE_CONTENT}
          </p>
        </Grid>
        <div>
          <MDCButton
            variant="outlined"
            label={"Neuen QR Code generieren"}
            onClick={this.generateQRCode}
            disabled={isAdminAndSupportUser || this.props.isDetailDialog}
            endIcon={<RefreshIcon />}
          />
        </div>
        <div>
          {this.state.loadingQRCode ? (
            <div className={classes.QRLoader}>
              <MDCLoader />
            </div>
          ) : (
            <>
              {this.state.QRCodeURL && (
                <img alt="Vollmacht QR Code" src={this.state.QRCodeURL} />
              )}
            </>
          )}
        </div>
      </>
    );
    const qesStepOneRemoteIdentView = (
      <>
        <Grid marginBottom=".25rem">
          <MDCLabel label={"Remote-Identifizierung URL"} variant="h6" />
        </Grid>
        {this.state.remoteIdentUrl ? (
          <>
            <MDCText
              name="remoteURL"
              value={this.state?.remoteIdentUrl}
              readOnly
              inputProps={{ maxLength: 255 }}
              endAdornment={
                <InputAdornment position="start">
                  <IconButton
                    onClick={() => {
                      this.copyRemoteIdentURL();
                    }}
                    edge="end"
                  >
                    <CopyContentIcon />
                  </IconButton>
                </InputAdornment>
              }
            />
            <Grid marginTop={".5rem"} width="90%">
              <MDCLabel
                className={classes.copyCotent}
                label="Bitte kopieren Sie die oben angezeigte URL und senden Sie diese zum User, um die Remote-Identifizierung durchzuführen."
              />
              <p className={`${classes.copyCotent} ${classes.contentCopyText}`}>
                Die URL funktioniert nur, wenn sie in einem Webbrowser geöffnet
                wird.
              </p>
            </Grid>
          </>
        ) : (
          <Grid
            container
            flexDirection={"column"}
            width="95%"
            marginBottom={"1rem"}
          >
            <MDCButton
              variant="outlined"
              label={"URL generieren"}
              onClick={() => {
                this.startRemoteIdentURL();
              }}
              disabled={isAdminAndSupportUser}
            />
          </Grid>
        )}
      </>
    );
    const qesStepTwoLocalIdentView = (
      <>
        <Grid textAlign="center" marginBottom="1.5rem">
          <MDCLabel label="Vollmachterstellung via Verimi" variant="h6" />
          <p>{VollmachtFormConstants.STEP_TWO_CONTENT}</p>
        </Grid>

        <div className={`${classes.vollmachtImage} ${classes.verimiImage}`} />
      </>
    );
    const qesStepTwoRemoteIdentView = (
      <>
        <Grid textAlign="center" marginBottom="1.5rem">
          <MDCLabel label="Remote-Identifizierungsprozess" variant="h6" />
          <p>{VollmachtFormConstants.STEP_TWO_REMOTE_CONTENT}</p>
        </Grid>
        <Grid container justifyContent={"center"} marginBottom={"8rem"}>
          <DesktopIcon color={theme.palette.MDCColors.color23} />
        </Grid>
      </>
    );
    const qesStepThreeLocalIdentView = (
      <>
        <p className={classes.contentLeftAlign}>
          {VollmachtFormConstants.STEP_THREE_LOCAL_CONTENT}
        </p>
      </>
    );
    const qesStepThreeRemoteIdentView = (
      <>
        <p className={classes.contentLeftAlign}>
          {VollmachtFormConstants.STEP_THREE_REMOTE_CONTENT}
        </p>
      </>
    );
    const QESProcessView = (
      <div className={classes.qesPreviewSection}>
        <div className={classes.marginBottomStepper}>
          <MDCStepper step={blinkingValue} />
        </div>
        <Grid container spacing={3}>
          <Grid
            item
            xs={4}
            className={classes.vollmachtStep}
            id="step-1-container"
          >
            {qesType === "REMOTE"
              ? qesStepOneRemoteIdentView
              : qesStepOneLocalIdentView}
          </Grid>

          <Grid item xs={4} className={classes.vollmachtStep}>
            {qesType === "REMOTE"
              ? qesStepTwoRemoteIdentView
              : qesStepTwoLocalIdentView}
          </Grid>

          <Grid
            item
            xs={4}
            className={`${classes.vollmachtStep} ${classes.vollmachtStep3rd}`}
            id="step-3-container"
          >
            <Grid width="18rem" marginBottom="2.5rem">
              <MDCLabel label="Vollmacht empfangen" variant="h6" />
              {qesType === "REMOTE"
                ? qesStepThreeRemoteIdentView
                : qesStepThreeLocalIdentView}
            </Grid>

            {!this.state.showCheckmark ? (
              blinkingValue > 2 && (
                <>
                  <Grid marginTop="2.5rem" marginBottom="1rem">
                    Erstellt am{" "}
                    {moment(
                      this.props.vollmachtSigningStatus?.signedDate
                    ).format("DD.MM.YYYY")}{" "}
                    um{" "}
                    {`${moment(
                      this.props.vollmachtSigningStatus?.signedDate
                    ).format("HH:mm")} Uhr und betreut durch ${
                      this.props?.vollmachtSigningStatus?.initiatedByUser
                    }`}
                  </Grid>
                  <div className={classes.downloadInput}>
                    <label
                      onDoubleClick={() =>
                        this.handleFile(
                          this.props?.formValues?.vollmachtsprozess?.value,
                          PREVIEW
                        )
                      }
                    >
                      {this.props?.formValues?.vollmachtsprozess?.value ===
                      "Einzelvollmacht"
                        ? "Einzelvollmacht"
                        : "Dauervollmacht"}
                    </label>
                    <div
                      onClick={() =>
                        this.handleFile(
                          this.props?.formValues?.vollmachtsprozess?.value,
                          DOWNLOAD
                        )
                      }
                      className={`${classes.vollmachtImage} ${classes.vollmachtDownloadPDF}`}
                    />
                  </div>
                  {!(
                    this.props.halterFormValues.Vorhanden.value ||
                    this.props.halterFormValues.steuerbefreiung.value
                  ) && (
                    <div className={classes.downloadInput}>
                      <label
                        onDoubleClick={() =>
                          this.handleFile("SEPA-Mandat", PREVIEW)
                        }
                      >
                        SEPA-Mandat
                      </label>
                      <div
                        onClick={() => {
                          this.handleFile("SEPA-Mandat", DOWNLOAD);
                        }}
                        className={`${classes.vollmachtImage} ${classes.vollmachtDownloadPDF}`}
                      />
                    </div>
                  )}

                  {this.props.halterFormValues?.addressDocument?.value ? (
                    <div className={classes.downloadInput}>
                      <label
                        onDoubleClick={() =>
                          this.handleFile("Adressnachweis", PREVIEW)
                        }
                      >
                        Adressnachweis
                      </label>
                      <div
                        onClick={() =>
                          this.handleFile("Adressnachweis", DOWNLOAD)
                        }
                        className={`${classes.vollmachtImage} ${classes.vollmachtDownloadPDF}`}
                      />
                    </div>
                  ) : this.props?.halterFormValues?.addressDocument?.value ? (
                    <>
                      <div className={classes.downloadInput}>
                        <label
                          onDoubleClick={() =>
                            this.handleFile(
                              "Adressnachweis des Unternehmens",
                              PREVIEW
                            )
                          }
                        >
                          Adressnachweis des Unternehmens
                        </label>
                        <div
                          onClick={() =>
                            this.handleFile(
                              "Adressnachweis des Unternehmens",
                              DOWNLOAD
                            )
                          }
                          className={`${classes.vollmachtImage} ${classes.vollmachtDownloadPDF}`}
                        />
                      </div>
                    </>
                  ) : null}
                </>
              )
            ) : (
              <div className={classes.circleLoader}>
                <div className={classes.checkMarkDraw} />
              </div>
            )}

            {isAllowedBasketInfoRead &&
              Object.keys(this.state.qesSupportData).length > 0 &&
              this.state.qesSupportData?.qesType && (
                <QESSupportDataBox qesSupportData={this.state.qesSupportData} />
              )}
          </Grid>
        </Grid>
      </div>
    );

    const poaDocumentUploadView = (
      <>
        <Grid container>
          <Grid item xs={6}>
            <label className={classes.columnTitle}>
              {VOLLMACHT_UPLOADED_FILE_DETAIL_VIEW}
            </label>
            {/*// If vorhanden checkbox is checked then SEPA-Mandat Document upload button will not be visible*/}
            {Object.keys(PPOAdocumentNames).map((docName, index) => {
              const uploadedFileData =
                docName === "addressDocument"
                  ? this.props.halterFormValues?.addressDocument?.value
                  : this.props.formValues[docName]?.value;

              return (
                <DocumentUpload
                  key={index}
                  documentName={docName}
                  uploadedFileData={uploadedFileData}
                  isDownloadDetailView
                  isDetailDialog={
                    this.props?.isDetailDialog ||
                    this.props?.formValues?.unterzeichnungsprozess?.value ===
                      "PPOA"
                  }
                  isShowUploadedLabel={
                    this.props?.formValues?.unterzeichnungsprozess?.value !==
                    "PPOA"
                  }
                  isPPOA={
                    this.props?.formValues?.unterzeichnungsprozess?.value ===
                    "PPOA"
                  }
                />
              );
            })}
          </Grid>
        </Grid>
      </>
    );

    const documentUploadView = (
      <>
        <Grid container spacing="2">
          {!this.props.isDetailDialog && (
            <Grid item xs={6} padding={"2rem"}>
              {this.props?.formValues?.unterzeichnungsprozess.value ===
                SIGNING_PROCESSING_TYPE.FILE_UPLOAD && (
                <>
                  <MDCTextWithDescription
                    label={PREFILLED_DOCUMENTS_TITLE}
                    description={PREFILLED_DOCUMENTS_DESCRIPTION}
                  >
                    <MDCButton
                      className={classes.prefilledDocumentButtonWidth}
                      variant="outlined"
                      label={PREFILLED_DOCUMENTS_BUTTON_LABEL}
                      disabled={
                        !this.state?.showPrefilledDocuments ||
                        this.state?.showPrefilledDocumentsLoader
                      }
                      onClick={() => this.downloadPrefilledDocuments()}
                    />
                    {this.state?.showPrefilledDocumentsError &&
                      !this.props?.isDetailDialog && (
                        <div className={classes.prefilledDocumentError}>
                          <ErrorText error={PREFILLED_DOCUMENTS_FORM_ERROR} />
                        </div>
                      )}
                  </MDCTextWithDescription>
                  {!isVWAGGroup() && (
                    <>
                      <div className={classes.centerDivider}>
                        <MDCCenteredDivider label="Oder" />
                      </div>

                      <MDCTextWithDescription
                        label={SIGNATURE_PROCESS_DOCUMENTS_EMAIL}
                        description={
                          SIGNATURE_PROCESS_DOCUMENTS_EMAIL_NP_DESCRIPTION
                        }
                      >
                        <MDCButton
                          className={classes.prefilledDocumentButtonWidth}
                          variant="outlined"
                          label={SIGNATURE_PROCESS_DOCUMENTS_BUTTON_LABEL}
                          onClick={() =>
                            this.setState({
                              showSignatureSendEmail: true,
                            })
                          }
                          disabled={
                            !this.state?.showPrefilledDocuments ||
                            this.state?.showPrefilledDocumentsLoader
                          }
                        />
                        {this.state?.showPrefilledDocumentsError &&
                          !this.props?.isDetailDialog && (
                            <div className={classes.prefilledDocumentError}>
                              <ErrorText
                                error={PREFILLED_DOCUMENTS_FORM_ERROR}
                              />
                            </div>
                          )}
                      </MDCTextWithDescription>
                    </>
                  )}

                  {this.state?.showSignatureSendEmail && (
                    <SignatureSendEmailPopupNP
                      show={this.state?.showSignatureSendEmail}
                      handlePopupClose={this.handleCloseSendEmail}
                      requestId={this.props.requestId}
                      vollmatchtType={SIGNING_PROCESSING_TYPE.QES}
                      vorname={this.props.halterFormValues?.vorname?.value}
                      nachname={
                        this.props.halterFormValues
                          ?.auskunft_NatuerlichePerson_FamiliennameNachname
                          ?.value
                      }
                      contactEmail={this.props.user?.email}
                      halterType={formConstants.individualPerson}
                    />
                  )}
                </>
              )}
            </Grid>
          )}

          <Grid item xs={6} padding={"1rem"}>
            <MDCTextWithDescription
              label={
                this.props.isDetailDialog
                  ? VOLLMACHT_UPLOADED_FILE_DETAIL_VIEW
                  : VOLLMACHT_FILE_UPLOAD
              }
              description={
                !this.props.isDetailDialog && VOLLMACHT_FILE_UPLOAD_DESCRIPTION
              }
            >
              {/*// If vorhanden checkbox is checked then SEPA-Mandat Document upload button will not be visible*/}
              {Object.keys(documentNames).map((docName, index) => {
                {
                  /**Showing only one document upload of
                  Daurvollmacht in case of groskundennummer checkbox is checked*/
                }

                return index === 1 &&
                  (this.props.halterFormValues.Vorhanden.value ||
                    this.props.halterFormValues.steuerbefreiung.value !==
                      "") ? null : (
                  <Grid className={classes.textWrapCSS}>
                    <DocumentUpload
                      key={index}
                      documentName={docName}
                      uploadedFileData={this.props.formValues[docName]?.value}
                      handleChange={(e) => this.props.handleChange(e, 4)}
                      isDetailDialog={this.props?.isDetailDialog}
                      isShowUploadedLabel={
                        this.props?.formValues?.unterzeichnungsprozess
                          ?.value !== "PPOA"
                      }
                      isPPOA={
                        this.props?.formValues?.unterzeichnungsprozess
                          ?.value === "PPOA"
                      }
                    />

                    {!this.props?.isDetailDialog && (
                      <ErrorText
                        id="file-upload-error"
                        error={this.props.formValues[docName]?.error}
                      />
                    )}
                  </Grid>
                );
              })}
            </MDCTextWithDescription>
          </Grid>
        </Grid>
      </>
    );

    const disableQESVendorActions =
      this.props?.isVollmachtCompleted ||
      this.props?.readOnly ||
      this.props?.isVollmachtTabDissable ||
      this.props?.isDetailDialog;

    // Resume an already-initiated QES on an existing record. Verimi is detected
    // via qesType (its flow depends on it); any other provider with a running/
    // completed signing status reopens the QES signing screen instead.
    const existingQESVendor = this.getExistingQESVendor();
    const isExistingNonVerimiQES =
      !!this.props?.vollmachtSigningStatus?.currentStage &&
      !!existingQESVendor &&
      existingQESVendor.providerId !== VERIMI_VENDOR_KEY;
    const isExistingQESInDetailsDialog =
      this.props?.isDetailDialog &&
      !!this.props?.vollmachtSigningStatus?.currentStage &&
      !!(
        this.props?.existingQesProvider ||
        this.props?.vollmachtSigningStatus?.qesProvider ||
        this.props?.vollmachtSigningStatus?.qesType
      );
    const isQESFlowActive =
      this.props?.formValues?.unterzeichnungsprozess?.value ===
        SIGNING_PROCESSING_TYPE.QES || isExistingQESInDetailsDialog;

    // Single source for the vendor picker — rendered both when the user cancels
    // back to the picker and on the default first-load branch of the QES flow.
    const qesVendorPicker = (
      <QESProviderSelection
        personenform={personenform}
        requestId={this.props.requestId}
        qesValidationResult={this.props?.vollmachtTabStatus}
        isVollmachtTabDissable={this.props?.isVollmachtTabDissable}
        disabled={disableQESVendorActions}
        startSigning={this.props.startQESSigning}
        onStartSigning={this.handleQESVendorStart}
      />
    );

    return (
      <>
        <div
          className={`${classes.formBackGround} ${
            this.props.isDetailDialog ? classes?.detailViewBackground : ""
          } ${
            this.props?.isVollmachtCompleted ? classes.vollmachtCompleted : ""
          }`}
        >
          {this.props.vollmachtSigningStatus?.errorMessage?.length && (
            <Grid marginBottom={"1.5rem"}>
              <MDCBanner
                message={this.props.vollmachtSigningStatus?.errorMessage}
                error
              />
            </Grid>
          )}

          {personenform === "naturliche" && (
            <>
              <Grid container spacing={2}>
                <Grid item xs={4} className={classes.fieldGroup}>
                  <Grid marginY={".5rem"}>
                    <label className={classes.columnTitle}>
                      {VollmachtRadioSteps.QES_SECTION_TITLE}
                    </label>

                    <FormControl component="fieldset">
                      <RadioGroup
                        aria-label="unterzeichnungsprozess"
                        name="unterzeichnungsprozess"
                        value={
                          this.props?.formValues?.unterzeichnungsprozess?.value
                        }
                        onChange={(e) => this.handleDocumentAvailableChange(e)}
                      >
                        {this.props.isPpoaApplied && (
                          <FormControlLabel
                            value="PPOA"
                            control={<Radio />}
                            className={defaultRadioButtonStyles}
                            label="Bestehende Dauervollmacht nutzen"
                            disabled={
                              this.props?.isVollmachtCompleted ||
                              this.props?.readOnly ||
                              this.props.isPpoaApplied ||
                              this.props?.isDetailDialog
                            }
                          />
                        )}

                        <FormControlLabel
                          value={SIGNING_PROCESSING_TYPE.QES}
                          control={<Radio />}
                          className={defaultRadioButtonStyles}
                          label={VollmachtRadioSteps.QES_STEP_1_TITLE}
                          disabled={
                            this.props?.isVollmachtCompleted ||
                            this.props?.readOnly ||
                            this.props.isPpoaApplied ||
                            this.props?.isDetailDialog
                          }
                        />
                        <p className={classes?.vollmachtSubHeading}>
                          {VollmachtRadioSteps.QES_STEP_1_SUB_TITLE}
                        </p>

                        {!this.props?.isDetailDialog &&
                          this.props?.vollmachtTabStatus === false &&
                          this.props?.formValues?.unterzeichnungsprozess
                            ?.value === SIGNING_PROCESSING_TYPE.QES && (
                            <ErrorText
                              error={`Bitte füllen Sie alle Pflichtfelder und klicken Sie auf "Speichern und Prüfen", um den QES-Prozess zu starten.`}
                            />
                          )}

                        <FormControlLabel
                          value={SIGNING_PROCESSING_TYPE.FILE_UPLOAD}
                          control={<Radio />}
                          className={defaultRadioButtonStyles}
                          label={VollmachtRadioSteps.QES_STEP_2_TITLE}
                          disabled={
                            this.props?.isVollmachtCompleted ||
                            this.props?.readOnly ||
                            this.props.isPpoaApplied ||
                            this.props?.isDetailDialog
                          }
                        />

                        <p className={classes?.vollmachtSubHeading}>
                          {VollmachtRadioSteps.QES_STEP_2_SUB_TITLE}
                        </p>
                      </RadioGroup>

                      {!this.props?.isDetailDialog && (
                        <ErrorText
                          error={this.state.isVollmachtDocumentError}
                        />
                      )}
                    </FormControl>
                  </Grid>
                </Grid>

                <Grid item xs={8} className={classes.fieldGroup}>
                  <Grid marginY={".5rem"}>
                    {this.props?.formValues?.unterzeichnungsprozess?.value ===
                    SIGNING_PROCESSING_TYPE.FILE_UPLOAD ? (
                      documentUploadView
                    ) : isQESFlowActive ? (
                      this.state.selectedQESVendor ? (
                        this.state.selectedQESVendor.vendor.providerId ===
                        VERIMI_VENDOR_KEY ? (
                          <>
                            <QESProviderBanner
                              provider={this.state.selectedQESVendor.vendor}
                              onCancel={this.handleQESVendorCancelRequest}
                              isComplete={this.props?.isVollmachtCompleted}
                              disabled={
                                this.props?.isVollmachtCompleted ||
                                this.props?.readOnly ||
                                this.props?.isDetailDialog
                              }
                            />
                            <Grid marginBottom={"1rem"}>
                              <MDCRadioButton
                                row
                                name="qesType"
                                selected={qesType}
                                options={qesIdentOptions}
                                onChange={(e) => this.handleQESIdentChange(e)}
                                disabled={
                                  this.props?.isVollmachtCompleted ||
                                  this.props?.readOnly ||
                                  this.props?.isDetailDialog
                                }
                              />
                            </Grid>
                            {QESProcessView}
                          </>
                        ) : (
                          <QESSigningStartScreen
                            vendor={this.state.selectedQESVendor.vendor}
                            holderFirstName={
                              this.props?.halterFormValues?.vorname?.value
                            }
                            holderLastName={
                              this.props?.halterFormValues
                                ?.auskunft_NatuerlichePerson_FamiliennameNachname
                                ?.value ||
                              this.props?.halterFormValues?.nachname?.value
                            }
                            onCancel={this.handleQESVendorCancelRequest}
                            onDownloadPrefilledDocuments={
                              this.downloadPrefilledDocuments
                            }
                            onStartQESProcess={
                              this.handleStartQESProviderProcess
                            }
                            signingStatus={this.props.vollmachtSigningStatus}
                            documents={this.getQESSignedDocuments()}
                            onDownloadDocument={(fileKey) =>
                              this.handleFile(fileKey, DOWNLOAD)
                            }
                            disabled={disableQESVendorActions}
                            halterFormValues={this.props?.halterFormValues}
                            isDetailDialog={this.props?.isDetailDialog}
                          />
                        )
                      ) : this.state.showQESVendorSelection ? (
                        qesVendorPicker
                      ) : this.props?.vollmachtSigningStatus?.currentStage &&
                        (this.props?.existingQesProvider ||
                          this.props?.vollmachtSigningStatus?.qesProvider ||
                          this.props?.vollmachtSigningStatus?.qesType) ? (
                        isExistingNonVerimiQES ? (
                          <QESSigningStartScreen
                            vendor={existingQESVendor}
                            holderFirstName={
                              this.props?.halterFormValues?.vorname?.value
                            }
                            holderLastName={
                              this.props?.halterFormValues
                                ?.auskunft_NatuerlichePerson_FamiliennameNachname
                                ?.value ||
                              this.props?.halterFormValues?.nachname?.value
                            }
                            onCancel={this.handleQESVendorCancelRequest}
                            onDownloadPrefilledDocuments={
                              this.downloadPrefilledDocuments
                            }
                            onStartQESProcess={
                              this.handleStartQESProviderProcess
                            }
                            signingStatus={this.props.vollmachtSigningStatus}
                            documents={this.getQESSignedDocuments()}
                            onDownloadDocument={(fileKey) =>
                              this.handleFile(fileKey, DOWNLOAD)
                            }
                            disabled={disableQESVendorActions}
                            halterFormValues={this.props?.halterFormValues}
                            isDetailDialog={this.props?.isDetailDialog}
                          />
                        ) : (
                          <>
                            <QESProviderBanner
                              provider={LEGACY_VERIMI_VENDOR}
                              onCancel={this.handleQESVendorCancel}
                              isComplete={this.props?.isVollmachtCompleted}
                              disabled={
                                this.props?.isVollmachtCompleted ||
                                this.props?.readOnly ||
                                this.props?.isDetailDialog
                              }
                            />
                            {QESProcessView}
                          </>
                        )
                      ) : (
                        qesVendorPicker
                      )
                    ) : null}
                    {this.props?.formValues?.unterzeichnungsprozess?.value ===
                      "PPOA" && poaDocumentUploadView}
                  </Grid>
                </Grid>
              </Grid>
            </>
          )}
        </div>

        <Grid item xs={12}>
          <MessageDialog
            show={this.state.displayMessage}
            messageFor={this.state.messageFor}
            handleDialogClose={this.handleDialogClose}
          />
        </Grid>
        {this.state.displayIdentSwitchModal && (
          <Grid item xs={12}>
            <MDCModal
              open={this.state.displayIdentSwitchModal}
              title={getModalHeader()}
              body={getModalBody()}
              size="sm"
            />
          </Grid>
        )}

        {this.state.displayQESTypeSwitchModal && (
          <Grid item xs={12}>
            <NPQESTypeSwitchModal
              isLoading={this.state.isNPQESTypeSwitch}
              show={this.state.displayQESTypeSwitchModal}
              processType={this.state.vollmachtProcess}
              handleCloseQESTypeSwitchModal={this.handleCloseQESTypeSwitchModal}
              handleVollmachtProcess={this.handleVollmachtProcess}
            />
          </Grid>
        )}

        {/* Delete QES Confirmation */}
        {this.state.showQESVendorCancelConfirm && (
          <DeleteProviderFlow
            showQESVendorCancelConfirm={this.state.showQESVendorCancelConfirm}
            handleHideQESVendorCancelConfirm={
              this.handleHideQESVendorCancelConfirm
            }
            handleQESVendorConfirm={this.handleQESVendorConfirmCancel}
          />
        )}
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    QRCode: state.manualRequestFormReducer.QRCode,
    vollmachtSigningStatus:
      state.manualRequestFormReducer.vollmachtSigningStatus,
    existingQesProvider: state.manualRequestFormReducer.existingQesProvider,
    user: state.authentication.user,
    vorgangeDetails: state.vorgangeDetailsReducer.vorgangeDetails,
    vorgangQESUpdatedRecordId: state.socketReducer.vorgangQESUpdatedRecordId,
    qesProviders: state?.pluginReducer?.qesProviders,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    getQESSupportData: (requestId, source) =>
      dispatch(manualRequestFormActions.getQESSupportData(requestId, source)),
    getVollmachtSigningStatus: (requestId) =>
      dispatch(manualRequestFormActions.getVollmachtSigningStatus(requestId)),
    startQESProcess: (requestId, payload) =>
      dispatch(manualRequestFormActions.startQESProcess(requestId, payload)),
    resetVollmachtSignedData: () =>
      dispatch(manualRequestFormActions.resetVollmachtSignedData()),
    createManualEntry: (data, requestId, createNewRequest) =>
      dispatch(
        manualRequestFormActions.createManualEntry(
          data,
          requestId,
          createNewRequest
        )
      ),
    getRemoteIdentURL: (requestId) =>
      dispatch(VollmachtRequestFormAction.getRemoteIdentURL(requestId)),
    startQESSigning: (requestId, vendorKey, personenform) =>
      dispatch(
        VollmachtRequestFormAction.startQESSigning(
          requestId,
          vendorKey,
          personenform
        )
      ),
    deleteQESDetails: (requestId) =>
      dispatch(manualRequestFormActions.deleteQESDetails(requestId)),
    getQRCode: (requestId, QRCodeStatus) =>
      dispatch(manualRequestFormActions.getQRCode(requestId, QRCodeStatus)),
    resetQRCode: () => dispatch(manualRequestFormActions.resetQRCode()),
    getPrefilledDocumentStatus: (requestId) =>
      dispatch(
        VollmachtRequestFormAction.getPrefilledDocumentStatus(requestId)
      ),
    getPrefilledDocumentsDownload: (requestId) =>
      dispatch(
        VollmachtRequestFormAction.getPrefilledDocumentsDownload(requestId)
      ),
    getVorgangQESUpdatedFromSocketEvent: (recordId) =>
      dispatch(socketActions.getVorgangQESUpdatedFromSocketEvent(recordId)),
  };
};

VollmachtRequestFormNP.propTypes = {
  vorgangeDetails: PropTypes.object,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(VollmachtRequestFormNP));
